import Lenis from '@studio-freight/lenis';
import Rellax from 'rellax';
import AOS from 'aos';

let lenisInstance = null;
let rellaxInstance = null;
let aosInited = false;

export function resetAOSAnimations() {
    document.querySelectorAll('[data-aos].aos-animate').forEach((el) => {
        el.classList.remove('aos-animate');
    });
}

export function refreshAOSHard() {
    try {
        AOS.refreshHard();
    } catch (_) { }
}

export function destroyMotion() {
    try {
        rellaxInstance?.destroy?.();
    } catch (_) { }
    rellaxInstance = null;

    try {
        lenisInstance?.destroy?.();
    } catch (_) { }
    lenisInstance = null;
}

export function initMotion() {
    const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;

    // AOS (subtle): only if there are elements using it.
    if (!reduced && document.querySelector('[data-aos]')) {
        if (!aosInited) {
            AOS.init({
                once: true,
                duration: 650,
                easing: 'ease-out-cubic',
                offset: 80,
            });
            aosInited = true;
        }

        // Ensure AOS recalculates positions (especially important with Swup/Lenis).
        requestAnimationFrame(() => refreshAOSHard());
    }

    // Lenis: enable only on desktop + not reduced motion.
    const canHover = window.matchMedia?.('(hover: hover) and (pointer: fine)')?.matches;
    if (!reduced && canHover) {
        if (!lenisInstance) {
            lenisInstance = new Lenis({
                smooth: true,
                lerp: 0.09,
                wheelMultiplier: 0.9,
                touchMultiplier: 0.9,
            });

            // Keep AOS in sync with Lenis (Lenis can bypass native scroll events).
            // Use native scroll listener instead to avoid conflicts.
            if (aosInited) {
                window.addEventListener('scroll', () => {
                    try {
                        AOS.refresh();
                    } catch (_) { }
                }, { passive: true });
            }

            const raf = (time) => {
                if (!lenisInstance) return;
                lenisInstance.raf(time);
                requestAnimationFrame(raf);
            };
            requestAnimationFrame(raf);
        } else {
            lenisInstance.resize?.();
        }
    }

    // Rellax: only if there are parallax elements.
    if (!reduced && document.querySelector('[data-rellax-speed]')) {
        try {
            rellaxInstance?.destroy?.();
        } catch (_) { }

        rellaxInstance = new Rellax('[data-rellax-speed]', {
            center: true,
            round: true,
        });
    }
}

document.addEventListener('DOMContentLoaded', initMotion);
